import { DIECASTS_MAIN_CATEGORY } from '../constants/dropdownIdPairs';
import {
    DEFAULT_RACE_USED_MAIN_CATEGORY,
    resolveCategoryModeSwitch,
} from './vaultBrowseCategories';
import { normalizeCollectibleSort } from './vaultCollectibleSort';

export const buildCollectibleSearchParams = (formData, {
    isDiecastsMode = false,
    sortBy = 'recent',
    page = '1',
    type = null,
    hasLikes = false,
} = {}) => {
    const params = new URLSearchParams();
    if (type) params.set('type', type);
    params.set('driver', formData?.driverName || '');
    params.set('series', formData?.series || '');
    params.set(
        'mainCategory',
        isDiecastsMode
            ? DIECASTS_MAIN_CATEGORY
            : (formData?.mainCategory ?? DEFAULT_RACE_USED_MAIN_CATEGORY)
    );
    params.set('subCategory', formData?.subCategory || '');
    params.set('subSubCategory', formData?.subSubCategory || '');
    params.set('subSubSubCategory', formData?.subSubSubCategory || '');
    params.set('sort', normalizeCollectibleSort(sortBy));
    params.set('page', String(page));
    if (hasLikes) params.set('hasLikes', '1');
    return params;
};

/** Apply category selection, switching collectibles ↔ diecasts mode when needed. */
export const buildCollectibleCategorySearch = (nextForm, {
    isDiecastsMode = false,
    sortBy = 'recent',
    type = null,
} = {}) => {
    const { isDiecastsMode: nextDiecastsMode, form } = resolveCategoryModeSwitch(nextForm, isDiecastsMode);
    const vaultType = type ?? (nextDiecastsMode ? 'diecasts' : 'collectibles');
    const params = buildCollectibleSearchParams(form, {
        isDiecastsMode: nextDiecastsMode,
        sortBy,
        page: '1',
        type: vaultType,
    });

    return { isDiecastsMode: nextDiecastsMode, form, params };
};

export const buildHeroSearchParams = (formData, {
    sortBy = 'recent',
    page = '1',
    type = 'heroCards',
} = {}) => {
    const params = new URLSearchParams();
    if (type) params.set('type', type);
    params.set('driver', formData?.driverName || '');
    params.set('series', formData?.series || '');
    params.set('year', formData?.year || '');
    params.set('sort', normalizeCollectibleSort(sortBy));
    params.set('page', String(page));
    return params;
};

export const navigateVaultSearch = (navigate, location, {
    basePath,
    params,
    onSameUrl,
}) => {
    const qs = params.toString();
    const nextPath = `${basePath}?${qs}`;
    const currentPath = `${location.pathname}${location.search}`;
    if (currentPath === nextPath || location.search === `?${qs}`) {
        onSameUrl?.();
        return false;
    }
    navigate(nextPath);
    return true;
};
